import { type SelectProps } from '@mantine/core';
import { TimeZoneInput } from '../../inputs/TimeZoneInput';
import { useEditorContext } from '../EditorContext';
import { setEditorFieldValue, type LooseKeys } from '../types';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalTimeZoneItemProps<TFormType> extends Omit<SelectProps, 'data' | 'value' | 'onChange'> {
    fieldKey: LooseKeys<TFormType>;
    required?: boolean;
    label?: string;
    labelWidth?: number;
}

export const ModalTimeZoneItem = <TFormType,>({
    fieldKey,
    required,
    label,
    labelWidth,
    ...timeZoneInputProps
}: ModalTimeZoneItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const error = form.errors[fieldKey];

    const handleChange = (value: string | null) => {
        setEditorFieldValue(form, fieldKey, value);
    };

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <TimeZoneInput
                value={form.getInputProps(fieldKey).defaultValue}
                key={form.key(fieldKey)}
                onChange={handleChange}
                disabled={loading}
                error={false}
                {...timeZoneInputProps}
            />
        </ModalEditorItemBase>
    );
};
